import { forwardRef, memo } from "react";
import ThreeDotsWave from "../ThreeDotsWave";
import TextInput, { type TextInputProps } from ".";

export interface TextInputWithLoadingProps {
  loading: boolean;
}

const ADORNMENT = (
  <div className="mr-3">
    <ThreeDotsWave dotClassName="bg-green-500" />
  </div>
);

const TextInputWithLoading = forwardRef(
  ({ loading, ...props }: TextInputWithLoadingProps & TextInputProps, ref: any) => (
    <TextInput ref={ref} adornment={loading ? ADORNMENT : undefined} {...props} />
  )
);

export default memo(TextInputWithLoading);
